// Event names
const runAnalytics = (func, ...args) => {
	try {
		// console.log('runAnalytics', func, ...args);
		if (window.analytics) {
			window.analytics[func](...args);
		}
	} catch (error) {
		console.log('error running analytics', error);
	}
};

const trackPageVisitedSegment = (/*route*/) => {
	// runAnalytics('page', route.name, { params: route.params })
	// window.analytics.page(route.name, { params: route.params }); // TODO - add extra params
};

const identifySegmentUser = (...args) => {
	// console.log('identifyUser', args);
	runAnalytics('identify', ...args);
};

const identifyGroup = (...args) => {
	// console.log('identifyGroup', args);
	runAnalytics('group', ...args);
};

export { trackPageVisitedSegment, identifySegmentUser, identifyGroup };
